import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { Typography } from '@mui/material';
import { AppPrimaryButton } from 'shared/components/AppComponents';

const CompletedModal: React.FC<Props> = React.forwardRef(
    (
        { callbackClosingModal, callbackOpenModal, onHandleSubmit },
        ref
    ): React.ReactElement => {
        const [open, setOpen] = React.useState(false);
        const handleOpen = React.useCallback((): void => {
            setOpen(true);
            if (typeof callbackOpenModal === 'function') callbackOpenModal();
        }, [callbackOpenModal]);
        const handleClose = React.useCallback((): void => {
            // setOpen(false);
            if (typeof callbackClosingModal === 'function')
                callbackClosingModal(null);
        }, [callbackClosingModal]);
        React.useImperativeHandle(
            ref,
            () => ({
                setClose: () => {
                    handleClose();
                },
                setOpen: () => {
                    handleOpen();
                },
            }),
            [handleOpen, handleClose]
        );

        return (
            <Box>
                <Modal
                    open={open}
                    disableEscapeKeyDown
                    onClose={handleClose}
                    aria-labelledby="parent-modal-title"
                    aria-describedby="parent-modal-description"
                >
                    <Box className="container-fix-completed-modal">
                        <Typography variant="h2" id="parent-modal-title">
                            Categorisation successful.
                        </Typography>
                        <Typography variant="h2" id="parent-modal-title">
                            Cross Check Status updated.
                        </Typography>
                        <Box className="container-completed-detail">
                            <Typography className="complete-detail">
                                This Cross Check is now verified
                            </Typography>
                            <Typography className="complete-detail">
                                Go to "Manage Cross Check" to review and
                                complete
                            </Typography>
                        </Box>
                        <Box
                            className="action-to-complete-fix-packet"
                            display="flex"
                        >
                            <AppPrimaryButton
                                title="Confirm & Proceed"
                                className="btn-small download"
                                onClick={onHandleSubmit}
                            />
                        </Box>
                    </Box>
                </Modal>
            </Box>
        );
    }
);

export default CompletedModal;
